var $62474c040a5c21d0$exports = {};
$62474c040a5c21d0$exports = {
    "endTime": `Hora final`,
    "startTime": `Hora inicial`,
    "time": `Hora`
};


export {$62474c040a5c21d0$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
